import { storeToRefs } from 'pinia';
import { computed, watch } from 'vue';

import useNotificationsModalStore from '@/stores/notifications_modal';
import useStationsStore from '@/stores/stations';

export const formatLocalTime = (utcString) => {
  if (!utcString) return null;
  return new Date(utcString).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
};

export const formatDuration = (seconds) => {
  if (seconds == null) return null;
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
};

const useStateNotifications = () => {
  const stationsStore = useStationsStore();
  const { selectedStationsList } = storeToRefs(stationsStore);
  const modalStore = useNotificationsModalStore();
  const lastKnownMessages = new Map();

  watch(
    selectedStationsList,
    (stations) => {
      const allMessages = [];

      for (const station of stations) {
        const msgs = station?.nateState?.messages ?? [];
        const stationLabel = [station.stationName, station.trackName].filter(Boolean).join(': ');

        for (const msg of msgs) {
          if (!msg.alert) continue;
          allMessages.push({
            ...msg,
            id: `${station.host}::${msg.id}`,
            station_label: stationLabel,
          });
        }
      }

      const currentIds = new Set(allMessages.map((m) => m.id));

      for (const [id, lastMsg] of lastKnownMessages) {
        if (!currentIds.has(id)) {
          modalStore._onMessageDeparted(id, lastMsg);
          lastKnownMessages.delete(id);
        }
      }

      for (const msg of allMessages) {
        lastKnownMessages.set(msg.id, msg);
      }

      modalStore._setActiveMessages([...allMessages]);
      modalStore._removeFromInactive(allMessages.map((m) => m.id));
    },
    { immediate: true, deep: true },
  );
};

export default useStateNotifications;
